import React, { useEffect, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import { Link, useNavigate } from "react-router-dom";
import { studentdashboardcount, studentdetail } from "../service/dashboard";
import moment from "moment";
import { Col, Row } from "react-bootstrap";

const Examination = () => {
    const navigate = useNavigate();
        const [edetail, setEDetail] = useState([]);
    
    useEffect(() => {
        if (localStorage.getItem("Role") === "4") {
            const temp = new FormData();
            temp.append("user_id", localStorage.getItem("UID"));
            studentdashboardcount(temp).then((res) => {
                if (res.status === true) {
                    studentdetail(res.data.students.id, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")).then((res1) => {
                        if (res1.status === true) {
                            if (res1.data.examdetails.length > 0) {
                                setEDetail(res1.data.examdetails);
                            }
                        }
                    });
                }
            })



        }
    }, []);

    const calculateGrandTotal = (details) => {
    return details.reduce((total, detail) => {
      const theoryMarks = parseInt(detail.exam_details_theory_mark) || 0;
      const practicalMarks = parseInt(detail.exam_details_pratical_mark) || 0;
      return total + theoryMarks + practicalMarks;
    }, 0);
  };
// Remove the marks which dont have thory mark or partical marks
//   const calculateGrandTotal = (details) => {
//   return details.reduce((total, detail) => {
//     const theoryMarks = parseInt(detail.exam_details_theory_mark);
//     const practicalMarks = parseInt(detail.exam_details_pratical_mark);

//     // Skip subjects where both theory and practical marks are not valid numbers or are zero
//     if ((isNaN(theoryMarks) || theoryMarks === 0) && (isNaN(practicalMarks) || practicalMarks === 0)) {
//       return total;
//     }

//     return total + (isNaN(theoryMarks) ? 0 : theoryMarks) + (isNaN(practicalMarks) ? 0 : practicalMarks);
//   }, 0);
// };



    const calculateTotalObtainedMarks = (details) => {
    return details.reduce((total, detail) => {
      const theoryMarks = parseInt(detail.theory_mark) || 0;
      const practicalMarks = parseInt(detail.practical_mark) || 0;
      return total + theoryMarks + practicalMarks;
    }, 0);
  };


    const calculatePercentage = (details) => {
    const totalObtainedMarks = calculateTotalObtainedMarks(details);
    const grandTotal = calculateGrandTotal(details);
    return grandTotal > 0 ? ((totalObtainedMarks / grandTotal) * 100).toFixed(2) : 0;
  };

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

        <div className="moreheading">
          <Row className="row-sm">
            <Col xs={6} className="text-left align-self-end">
              <h4 className="morehead-text">Examination</h4>
            </Col>
           
            <Col xs={6} className="text-right align-self-end">
              <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                <i className="fa-solid fa-hand-point-left"></i> Go Back
              </Link>
            </Col>

          </Row>
        </div>
                <div className="exam-result-container table-wrapper">
                    {edetail.length > 0 && edetail.map((item, index) => {
                        return (
                            <div key={index}>
                                <div className="d-md-flex ms-auto mb-2">
                                    <label className="my-auto pt-2 exam-title"><strong>{item.exam} ({item.year})</strong></label>
                                </div>
                                <table className="result-table">
                                    <thead>
                                        <tr>
                                            <th>Subject</th>
                                            <th>Theory Marks</th>
                                            <th>Practical Marks</th>
                                            <th>Min Marks</th>
                                            <th>Marks Obtained</th>
                                            <th>Result</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {item.details.map((detail, j) => {
                                            const obtainedMarks = (detail.theory_mark ?? 0) + (detail.practical_mark ?? 0);
                                            const totalMarks = (detail.exam_details_theory_mark ?? 0) + (detail.exam_details_pratical_mark ?? 0);

                                            return (
                                                <tr key={j}>
                                                    <td>{detail.subject_name} {detail.exam_date != null ? "(" + (moment(detail.exam_date).format("DD-MM-YYYY")) + ")" : ""} <br /> {detail.exam_time != null ? "(" + detail.exam_time + ")" : ""}</td>
                                                    <td>{detail.exam_details_theory_mark != null ? detail.exam_details_theory_mark : ''}</td>
                                                    <td>{detail.exam_details_pratical_mark != null ? detail.exam_details_pratical_mark : ''}</td>
                                                    <td>{detail.pass_marks != null ? detail.pass_marks : ''}</td>
                                                    <td>
                                                        {obtainedMarks}
                                                    </td>
                                                    <td><span className={obtainedMarks >= detail.pass_marks ? "result-pass" : "result-fail"}>{obtainedMarks >= detail.pass_marks ? "Pass" : "Fail"}</span></td>

                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                                <div className="result-summary">
                                    <p><strong>Percentage:</strong> {calculatePercentage(item.details)}%</p>
                                    {/* <p><strong>Rank:</strong> 10</p> */}
                                    <p><strong>Result:</strong> <span className={item.details.some(detail => ((detail.theory_mark ?? 0) + (detail.practical_mark ?? 0)) < detail.pass_marks) ? 'result-fail' : 'result-pass'}>
                                        {item.details.some(detail => ((detail.theory_mark ?? 0) + (detail.practical_mark ?? 0)) < detail.pass_marks) ? 'Fail' : 'Pass'}
                                    </span></p>
                                    {/* <p><strong>Grade:</strong> A+</p> */}
                                    <p><strong>Grand Total:</strong> {calculateGrandTotal(item.details)}</p>
                                    <p className="text-success"><strong>Total Obtained Marks:</strong> {calculateTotalObtainedMarks(item.details)}</p>
                                </div>
                                <hr></hr>
                            </div>
                        )
                    })
                    }

                    {edetail.length === 0 && (
                        <div className="d-md-flex ms-auto mb-2">
                            <label className="my-auto pt-2 exam-title"><strong>No Record Found</strong></label>
                        </div>
                    )}

                </div>

            </div>
            <Footer />
        </div>
    );
};

export default Examination;
